import { connect } from 'react-redux';
import SortParticipants from './SortParticipants';
import { fetchClassRoomParticipants } from '../../../../../../core/actions/classRoom/participants';

const mapDispatchToProps = (dispatch) => ({
  fetchParticipants: (sort, reset) =>
    dispatch(fetchClassRoomParticipants({ sort, reset })),
});

export default connect(null, mapDispatchToProps)(SortParticipants);
